import React from 'react';
import HoloCard from '../components/HoloCard';
import SafeIcon from '../common/SafeIcon';
import BrandLogo from '../components/BrandLogo';

const Settings = () => {
  return (
    <div className="space-y-8 max-w-4xl mx-auto">
      <div className="border-b border-cyan-900/30 pb-6">
        <h1 className="text-2xl font-light text-white tracking-wide">System <span className="font-bold text-cyan-400 italic uppercase tracking-tighter">Configuration</span></h1>
        <p className="text-slate-500 text-sm mt-1">Manage global operational parameters and security protocols.</p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <HoloCard title="Visual Interface Engine">
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-slate-900/40 rounded-lg border border-slate-800/50 group hover:border-cyan-500/30 transition-all">
              <div>
                <h4 className="text-slate-200 text-sm font-bold">Holographic UI Mode</h4>
                <p className="text-xs text-slate-500">Enable advanced shaders, scanlines, and glow effects.</p>
              </div>
              <div className="w-12 h-6 bg-cyan-900 rounded-full relative cursor-pointer border border-cyan-700 shadow-[inset_0_0_10px_rgba(0,0,0,0.5)]">
                <div className="absolute right-1 top-1 w-4 h-4 bg-cyan-400 rounded-full shadow-[0_0_10px_#22d3ee]"></div>
              </div>
            </div>

            <div className="flex items-center justify-between p-4 bg-slate-900/40 rounded-lg border border-slate-800/50">
              <div>
                <h4 className="text-slate-200 text-sm font-bold">Telemetry Refresh Rate</h4>
                <p className="text-xs text-slate-500">Global sync frequency for all connected nodes.</p>
              </div>
              <select className="bg-slate-950 border border-slate-700 text-xs text-cyan-400 px-3 py-1 rounded outline-none">
                <option>Real-time (500ms)</option>
                <option>Standard (2s)</option>
                <option>Battery Saver (10s)</option>
              </select>
            </div>
          </div>
        </HoloCard>

        <HoloCard title="Security & Compliance">
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-slate-900/40 rounded-lg border border-slate-800/50">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-amber-500/10 border border-amber-500/30 rounded text-amber-500">
                  <SafeIcon name="Shield" />
                </div>
                <div>
                  <h4 className="text-slate-200 text-sm font-bold">Level 4 Encryption</h4>
                  <p className="text-xs text-slate-500">AES-256 state-level data protection enabled.</p>
                </div>
              </div>
              <span className="text-[10px] font-mono text-emerald-500 bg-emerald-500/10 px-2 py-1 rounded border border-emerald-500/30 font-bold">ACTIVE</span>
            </div>
          </div>
        </HoloCard>
      </div>

      <div className="mt-16 py-12 flex flex-col items-center justify-center space-y-6 border-t border-slate-900/50">
        <BrandLogo size="lg" className="opacity-20 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-700 cursor-help" />
        <div className="text-center">
          <h2 className="text-lg font-bold text-white tracking-[0.3em] uppercase italic">OpsPrism</h2>
          <p className="text-[10px] font-mono text-slate-600 mt-2">BUILD_VERSION: 4.0.2_STABLE // KERNEL: 0x5521A</p>
          <div className="flex items-center justify-center space-x-4 mt-6">
            <div className="w-12 h-px bg-slate-900"></div>
            <p className="text-[10px] font-mono text-cyan-800 uppercase tracking-widest">
              Made by LingLink AI and DigLab AI
            </p>
            <div className="w-12 h-px bg-slate-900"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;